enum DashboardWidgetTypeEnum {
    DAILY_SALES = "daily_sales",
    WEEKLY_SALES = "weekly_sales",
    MONTHLY_SALES = "monthly_sales",
    LAST_YEAR_VOLUME = "last_year_volume",
    RECENT_ORDERS = "recent_orders",
    LAST_FIVE_INVENTORY = "last_five_inventory",
    ORDERS_AT_STEP = "orders_at_step",
    MONTHLY_ORDERS = "monthly_orders",
    MONTHLY_SHIPMENTS = "monthly_shipments",
    ACCOUNT_DETAIL_LOOKUP = "account_detail_lookup",
    REMOTE_URL = "remote_url",
    CREATE_ORDER = "create_order",
    FREIGHT_POLICY = "freight_policy",
    SALES_SUMMARY = "sales_summary",
    DUE_DATE_CALENDAR = "due_date_calendar",
    SYSTEM_MESSAGES = "system_messages",
    COOP_TOTAL = "coop_total",
    REBATE_TOTAL = "rebate_total",
}

export default DashboardWidgetTypeEnum;
